<template>
  <div class="rightTableDiv">
    <a-spin :spinning="spinning">
      <div class="topTitle">
        <div>
          <span @click="changeTabs(0)" :class="[activeTab === 0 ? 'activeColor' : 'Unchecked']" class="tabsSpan">特性配置</span>
          <span @click="changeTabs(1)" :class="[activeTab === 1 ? 'activeColor' : 'Unchecked']" class="tabsSpan" v-if="type !== 'add'">参数配置</span>
          <span @click="changeTabs(2)" :class="[activeTab === 2 ? 'activeColor' : 'Unchecked']" class="tabsSpan" v-if="type !== 'add'">台账字段配置</span>
        </div>
      </div>
      <!--    特性配置-->
      <feature-configuration
        ref="featureConfiguration"
        v-show="activeTab === 0"
        :viewConfirmDel="viewConfirmDel"
        :dataForm="dataForm1"
        @getDeviceTypeInfo="getDeviceTypeInfo"
        @refreshTreeParent="refreshTreeParent"
        @getTabData="getTabData"></feature-configuration>
      <!--      参数配置-->
      <parameter-configuration
        ref="parameterConfiguration"
        v-show="activeTab === 1"
        :viewConfirmDel="viewConfirmDel"
        :dataForm="dataForm2"
        @getParamsDetail="getParamsDetail"
        @getTabData="getTabData"></parameter-configuration>
      <!--      台账字段配置-->
      <ledger-field-configuration
        ref="ledgerFieldConfiguration"
        v-show="activeTab === 2"
        :viewConfirmDel="viewConfirmDel"
        :treeData="treeData"
        :fieldListData="fieldListData"
        @getLedgerFieldDetail="getLedgerFieldDetail"
        @getTabData="getTabData"></ledger-field-configuration>
    </a-spin>
  </div>
</template>
<script>
import { getDeviceTypeInfo, getParams, getTypeFieldByTypeCode, getTypeFieldDataByTypeId
} from '@/api/deviceType'
import featureConfiguration from '@/views/deviceType/modules/featureConfiguration'
import parameterConfiguration from '@/views/deviceType/modules/parameterConfiguration'
import ledgerFieldConfiguration from '@/views/deviceType/modules/ledgerFieldConfiguration'

export default {
  computed: {
    deviceTypeStatus () {
      return this.$store.state.deviceType.deviceTypeStatus
    },
    handleAuth () {
      if (this.type === 'add') {
        return this.$auth('deviceType.add')
      } else if (this.type === 'edit') {
        return this.$auth('deviceType.edit')
      } else {
        return false
      }
    }
  },
  components: {
    featureConfiguration,
    parameterConfiguration,
    ledgerFieldConfiguration
  },
  data () {
    return {
      tableData: {
        data: [],
        loading: false
      },
      labelCol: { style: 'width: 100px' },
      wrapperCol: { style: 'width: calc(100% - 100px)' },
      labelCol2: { style: 'width: 70px' },
      wrapperCol2: { style: 'width: calc(100% - 72px)' },
      labelColAll: {
        xs: { span: 24 },
        sm: { span: 0 }
      },
      wrapperColAll: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      sort: {},
      form: this.$form.createForm(this, { name: 'cancelApplication' }),
      spinning: false,
      loading: false,
      btnLoading: false,
      selectList: [
        {
          id: 0,
          name: '不包含'
        },
        {
          id: 1,
          name: '包含'
        }
      ],
      selectList2: [
        {
          id: 0,
          name: '停用'
        },
        {
          id: 1,
          name: '在用'
        }
      ],
      type: 'edit',
      // 当前选中的tab页
      activeTab: 0,
      // 常规参数选择列表
      generalList: [],
      generalVerifyList: [], // 验证
      generalDelList: [],
      // 其他参数列表
      otherData: [],
      otherDataDelList: [],
      // 特性配置列表
      featureList: [],
      featureVerifyList: [], // 验证
      featureOriginalList: [], // 原始
      featureDelList: [],
      // 图标列表
      iconList: [],
      // 常规参数列表
      generalParameterList: [],
      // 参数配置tab是否有删除
      activeTabDelOne: false,
      // 特性配置页面是否有删除
      activeTabDelTwo: false,
      // 当前页面是否需要确认删除
      viewConfirmDel: null,
      forceDelete: null,
      // 特性配置
      dataForm1: {},
      // 参数配置
      dataForm2: {},
      // 台账字段配置
      treeData: [],
      checkList: [],
      fieldListData: []
    }
  },
  watch: {
    deviceTypeStatus: {
      handler (newVal) {
        switch (newVal.type) {
          case 'edit':
            this.type = 'edit'
            // 获取特性配置
            this.getDeviceTypeInfo(newVal.data.id)
            // 获取参数配置
            this.getParamsDetail(newVal.data.id)
            // 获取台账字段配置
            this.getLedgerFieldDetail(newVal.data.id, newVal.data.code, true)
            break
          case 'rootAdd':
            this.type = 'add'
            this.dataForm1 = {}
            this.activeTab = 0
            this.$nextTick(() => {
              this.setFeatureConfigurationData({ ...newVal.data }, this.type)
            })
            break
          case 'childAdd':
            this.type = 'add'
            this.dataForm1 = {}
            this.activeTab = 0
            this.$nextTick(() => {
              this.setFeatureConfigurationData({ ...newVal.data }, this.type)
            })
            break
        }
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    // 获取特性配置数据
    async getDeviceTypeInfo (id, type) {
      this.spinning = true
      const res = await getDeviceTypeInfo(id)
      if (type) {
        this.type = type
      }
      if (res.status === 0) {
        res.data.peculiarityRelevancyList.forEach((item, index) => {
          item.id = index + 1
        })
        this.dataForm1 = res.data
        if (this.activeTab === 0) {
          this.setFeatureConfigurationData({ ...res.data }, this.type)
        }
      } else {
        this.$message.error(res.info.message)
      }
      // this.spinning = false
    },
    // 获取参数配置数据
    async getParamsDetail (typeId) {
      this.spinning = true
      const data = {
        typeId: typeId
      }
      await getParams(data).then(res => {
        if (res.status === 0) {
          res.data.paramList.forEach((item, index) => {
            item.equipmentTypeId = typeId
          })
          res.data.typeParamList.forEach((item, index) => {
            if (item.valueType === 1) {
              item.valueOptions = ''
            }
            item.requiredState = item.requiredState ? 1 : 0
          })
          this.dataForm2 = res.data
          if (this.activeTab === 1) {
            this.setParameterConfigurationData({ ...res.data }, this.type)
          }
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
      // this.spinning = false
    },
    // 获取台账字段配置
    async getLedgerFieldDetail (typeId, typeCode, loadingAll) {
      if (loadingAll) {
        this.spinning = true
      }
      const data = {
        typeCode: typeCode,
        type: 1
      }
      await getTypeFieldByTypeCode(data).then(res => {
        if (res.status === 0) {
          this.treeData = []
          this.checkList = []
          res.data.forEach((item, index) => {
            const data = {
              scopedSlots: { title: 'custom' },
              key: index,
              ...item
            }
            if (item.type === 1) {
              this.checkList.push(item.dataIndex)
            }
            this.treeData.push(data)
          })
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
      const data2 = {
        typeId: typeId,
        type: 1
      }
      await getTypeFieldDataByTypeId(data2).then(res => {
        if (res.status === 0) {
          res.data.paramList.forEach(item => {
            item.children.forEach(i => {
              i.disabled = i.status === 2
            })
          })
          this.fieldListData = res.data
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
      if (this.activeTab === 2 && loadingAll) {
        this.setLedgerConfigurationData()
      } else {
        this.$refs.ledgerFieldConfiguration.setTreeLoading(false)
      }
    },
    // 新增/编辑完成后调用3个tab页的接口获取数据
    async getTabData (data) {
      // 获取特性配置
      await this.getDeviceTypeInfo(data.id, data.type)
      // 获取参数配置
      await this.getParamsDetail(data.typeId)
      // 获取台账字段配置
      await this.getLedgerFieldDetail(data.typeId, data.typeCode, true)
      this.spinning = false
    },
    // 切换tab页
    changeTabs (num) {
      this.activeTab = num
      if (this.type === 'edit') {
        // 编辑
        if (this.activeTab === 0) {
          this.setFeatureConfigurationData(this.dataForm1, this.type)
        } else if (this.activeTab === 1) {
          this.setParameterConfigurationData(this.dataForm2, this.type)
        } else if (this.activeTab === 2) {
          this.setLedgerConfigurationData()
        }
      } else {
        // 新增
        this.setFeatureConfigurationData(this.deviceTypeStatus.data, this.type)
      }
    },
    // 设置特性配置的数据
    setFeatureConfigurationData (data, type) {
      this.$nextTick(() => {
        this.$refs.featureConfiguration.setType(type)
        this.$refs.featureConfiguration.initTableData(data)
        this.spinning = false
      })
    },
    // 设置参数配置的数据
    setParameterConfigurationData (data, type) {
      this.$nextTick(() => {
        this.$refs.parameterConfiguration.setType(type)
        this.$refs.parameterConfiguration.initTableData(data)
        this.spinning = false
      })
    },
    // 设置台账字段配置的数据
    setLedgerConfigurationData () {
      this.$nextTick(() => {
        this.$refs.ledgerFieldConfiguration.getBaseField()
        this.$refs.ledgerFieldConfiguration.setCheckList(this.checkList)
        const data = []
        this.fieldListData.fieldList.forEach(item => {
          if (item.type === 2) {
            // 基础参数
            const index = this.fieldListData.paramList.findIndex(item2 => item2.typeName === item.pName)
            const params = {
              field: Number(item.dataIndex),
              fieldList: index > -1 ? this.fieldListData.paramList[index].children : [],
              paramOrFeature: index,
              type: item.type
            }
            data.push(params)
          } else if (item.type === 3) {
          //  自定义参数
            const params = {
              field: Number(item.dataIndex),
              type: item.type
            }
            data.push(params)
          } else if (item.type === 4) {
          //  特性参数
            const params = {
              paramOrFeature: Number(item.dataIndex),
              type: item.type
            }
            data.push(params)
          }
        })
        this.$refs.ledgerFieldConfiguration.initTableData(data)
        this.spinning = false
      })
    },
    // 调用树接口刷新数据
    refreshTreeParent (res) {
      this.$emit('refreshTree', res.data)
    }
  }
}
</script>

<style scoped lang="less">
.rightTableDiv {
  height: 100%;
  overflow: hidden;
  padding-right: 12px;
}
/deep/.ant-spin-nested-loading {
  height: 100%;
  .ant-spin-container {
    height: 100%;
  }
}
.topTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 17px;
  span:nth-child(1) {
    margin-right: 12px;
  }
  span:nth-child(2) {
    margin-right: 12px;
  }
  .tabsSpan {
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
  }
  .activeColor {
    color: #1791FF;
  }
  .Unchecked {
    color: #B3B3B3;
  }
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: #08409F;
  }
}
.inputDiv {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}
/deep/.ant-form-item {
  display: flex;
  margin-bottom: 12px;
}
/deep/.ant-col-md-5 {
  width: 20% !important;
  margin-bottom: 12px;
}
/deep/.ant-col-md-9 {
  width: 40% !important;
  margin-bottom: 12px;
}
.generalParameter {
  /deep/.ant-col-6 {
    padding-left: 12px;
    .ant-form-item-children {
      display: flex;
      flex-direction: row;
      align-items: center;
      .ant-select {
        width: calc(100% - 28px);
        margin-right: 8px;
      }
      .delIcon {
        font-size: 20px;
        color: red;
      }
    }
  }
}
.addBtn_general {
  width: 100%;
  /deep/.anticon {
    color: #1791FF;
  }
}
.other-data{
  position: relative;
  height: calc(100% - 44px);
  .action-btn{
    position: absolute;
    right: 10px;
    top: -36px;
    display: flex;
    .btn{
      margin-left: 10px;
    }
  }
  .item-label{
    margin: 0 0 12px 0 !important;
    background: #F5F5F5;
    .ant-col {
      padding: 10px 8px;
      border-top: 1px solid #DDDDDD;
      border-bottom: 1px solid #DDDDDD;
      border-right: 1px solid #DDDDDD;
    }
    .ant-col:nth-child(1) {
      border-left: 1px solid #DDDDDD;
    }
    .anticon{
      color: #1791FF;
      font-size: 14px;
      margin-left: 9px;
      margin-right: 9px;
    }
    .anticonTooltip{
      color: #1791FF;
      font-size: 12px;
    }
  }
  .dataInputDiv {
    height: calc(100% - 70px);
    /deep/.ant-col {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .inputType {
      width: calc(100% - 32px);
      margin-right: 12px;
    }
  }
  .item-data{
    width: 100%;
    margin-bottom: 12px;
    .anticon{
      color: #E73B3B;
      font-size: 20px;
    }
  }
}
.fontWeight {
  font-weight: bold;
}
/deep/.ant-modal-confirm-title {
  font-weight: bold;
  font-size: 16px;
}
</style>
